function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_125",
  "data-name": "Rectangle 125",
  width: 155.844,
  height: 29.609,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_9886",
  "data-name": "Group 9886",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1448",
  "data-name": "Path 1448",
  d: "M30.946,86.719c0,2.8-6.927,5.066-15.473,5.066S0,89.519,0,86.719,6.929,81.66,15.473,81.66s15.473,2.268,15.473,5.059",
  transform: "translate(0 -62.175)",
  fill: "#afbd00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1449",
  "data-name": "Path 1449",
  d: "M37.456,24.823s-7.59,5.874-15.323.974A12.064,12.064,0,0,1,17.845,9.219c2.095-3.066,8.1-7.2,14.239-2.689,0,0,4.335,2.914,3.184,7.852-1.13,4.813-6.364,6.5-6.364,6.5C33.8,21.6,38.16,17,37.8,11.538A12.448,12.448,0,0,0,27.3.49a12.75,12.75,0,0,0-9.176,2.556C20.377.491,24.857-.674,29.266.4a13.775,13.775,0,0,1,10.2,11.814A10.532,10.532,0,0,1,30.21,23.8c-4.205.345-9.833-2.171-9.985-8.3S26.594,7.8,26.594,7.8s-2.028-1.644-5.571.9c0,0-5.316,3.532-3.017,10.624s11.4,10.7,19.451,5.5",
  transform: "translate(-12.304 0)",
  fill: "#004d99"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1450",
  "data-name": "Path 1450",
  d: "M24.463,20.435a10.254,10.254,0,0,0,2.695-8.222A13.775,13.775,0,0,0,16.961.4C12.553-.674,8.073.491,5.82,3.046A12.748,12.748,0,0,1,15,.49a12.447,12.447,0,0,1,10.5,11.048,9.068,9.068,0,0,1-4.146,8.327c-.733-.1-1.494-.177-2.276-.238a8.789,8.789,0,0,0,3.892-5.247C24.114,9.444,19.78,6.53,19.78,6.53,13.642,2.015,7.636,6.153,5.541,9.219a12.153,12.153,0,0,0-.4,11.569C1.988,21.715,0,23.052,0,24.544c0,2.8,6.929,5.066,15.473,5.066s15.473-2.266,15.473-5.066c0-1.7-2.562-3.19-6.484-4.109M5.7,19.32C3.4,12.229,8.719,8.7,8.719,8.7c3.543-2.544,5.571-.9,5.571-.9S7.781,9.374,7.921,15.5a8.224,8.224,0,0,0,1.34,4.41,31.1,31.1,0,0,0-3.092.595A10.69,10.69,0,0,1,5.7,19.32",
  transform: "translate(0 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1451",
  "data-name": "Path 1451",
  d: "M150.342,20.869h5.028a13.065,13.065,0,0,1,3.607.377,3.62,3.62,0,0,1,1.985,1.526,6.994,6.994,0,0,1,.754,3.7,3.971,3.971,0,0,1-.539,2.408,3.664,3.664,0,0,1-2.1,1.044,3.742,3.742,0,0,1,2.38,1.329,5.118,5.118,0,0,1,.63,2.854v1.823a7.308,7.308,0,0,1-.452,2.958A2.42,2.42,0,0,1,160.2,40.2a14.462,14.462,0,0,1-4.022.351h-5.836Zm5.055,3.363V28.6c.21-.008.378-.014.494-.014.491,0,.8-.121.937-.37a6.168,6.168,0,0,0,.2-2.12,3.5,3.5,0,0,0-.165-1.29.809.809,0,0,0-.427-.469,3.578,3.578,0,0,0-1.038-.107m0,7.439v5.516a2.068,2.068,0,0,0,1.341-.339,2.457,2.457,0,0,0,.288-1.5V33.51a2.67,2.67,0,0,0-.258-1.535,2.3,2.3,0,0,0-1.371-.3",
  transform: "translate(-114.469 -15.889)",
  fill: "#004d99"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1452",
  "data-name": "Path 1452",
  d: "M212.219,20.868V36.6H215.3v3.947h-8.135V20.868Z",
  transform: "translate(-157.734 -15.889)",
  fill: "#004d99"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1453",
  "data-name": "Path 1453",
  d: "M256.123,28.157h-5.054v-3.4a6,6,0,0,0-.161-1.851.683.683,0,0,0-.7-.372.739.739,0,0,0-.785.45,6.951,6.951,0,0,0-.169,1.939v9.123a6.452,6.452,0,0,0,.169,1.864.841.841,0,0,0,1.475,0,7.174,7.174,0,0,0,.174-2.054V31.384h5.054v.767a15.063,15.063,0,0,1-.429,4.326,4.332,4.332,0,0,1-1.88,2.24,6.366,6.366,0,0,1-3.588.959,7.391,7.391,0,0,1-3.656-.813,3.932,3.932,0,0,1-1.9-2.252,14.931,14.931,0,0,1-.467-4.33V26.542a26.98,26.98,0,0,1,.139-3.188,4.447,4.447,0,0,1,.864-2.043,4.709,4.709,0,0,1,1.977-1.55,7.987,7.987,0,0,1,6.582.309,4.154,4.154,0,0,1,1.908,2.17,13.252,13.252,0,0,1,.454,4.049Z",
  transform: "translate(-185.931 -14.617)",
  fill: "#004d99"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1454",
  "data-name": "Path 1454",
  d: "M301.706,20.868h5.082a11.705,11.705,0,0,1,3.174.332,3.5,3.5,0,0,1,1.666.947,3.284,3.284,0,0,1,.755,1.5,13.711,13.711,0,0,1,.2,2.729v1.713a7.3,7.3,0,0,1-.381,2.751,2.657,2.657,0,0,1-1.409,1.327,6.576,6.576,0,0,1-2.673.46h-1.354v7.917h-5.056Zm5.056,3.363v5.027c.143.006.267.011.371.011a1.166,1.166,0,0,0,.964-.346,2.6,2.6,0,0,0,.268-1.445V25.852a1.913,1.913,0,0,0-.31-1.318,1.916,1.916,0,0,0-1.293-.3",
  transform: "translate(-229.716 -15.889)",
  fill: "#004d99"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1455",
  "data-name": "Path 1455",
  d: "M371.491,20.868h5.082a11.669,11.669,0,0,1,3.174.332,3.506,3.506,0,0,1,1.661.947,3.323,3.323,0,0,1,.762,1.5,13.667,13.667,0,0,1,.194,2.729v1.713a7.38,7.38,0,0,1-.38,2.751,2.7,2.7,0,0,1-1.409,1.327,6.565,6.565,0,0,1-2.676.46h-1.355v7.917h-5.052Zm5.052,3.363v5.027c.149.006.271.011.376.011a1.162,1.162,0,0,0,.962-.346,2.616,2.616,0,0,0,.269-1.445V25.852a1.891,1.891,0,0,0-.311-1.318,1.929,1.929,0,0,0-1.3-.3",
  transform: "translate(-282.85 -15.889)",
  fill: "#004d99"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1456",
  "data-name": "Path 1456",
  d: "M434.288,31.12a41.256,41.256,0,0,1-.145,4.193,4.705,4.705,0,0,1-.859,2.251,4.6,4.6,0,0,1-1.963,1.567,7.069,7.069,0,0,1-2.881.546,7.222,7.222,0,0,1-2.8-.517,4.683,4.683,0,0,1-2-1.544,4.628,4.628,0,0,1-.9-2.25,40.922,40.922,0,0,1-.143-4.246V27.756q0-2.96.137-4.192a4.767,4.767,0,0,1,.861-2.251,4.63,4.63,0,0,1,1.964-1.566,7.051,7.051,0,0,1,2.878-.548,7.251,7.251,0,0,1,2.807.514,4.726,4.726,0,0,1,2.894,3.794,40.936,40.936,0,0,1,.147,4.249Zm-5.058-6.454a6.078,6.078,0,0,0-.149-1.752.584.584,0,0,0-.609-.383.7.7,0,0,0-.613.314,4.445,4.445,0,0,0-.206,1.822v9.168a8.717,8.717,0,0,0,.14,2.109.6.6,0,0,0,.64.4.625.625,0,0,0,.658-.46,10.058,10.058,0,0,0,.14-2.2Z",
  transform: "translate(-321.763 -14.618)",
  fill: "#004d99"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1457",
  "data-name": "Path 1457",
  d: "M495.265,20.868l-2.251,19.678h-6.28q-.866-4.53-1.54-10.333-.314,2.5-1.4,10.333h-6.245l-2.259-19.678h4.892l.53,6.873.513,6.64q.3-5.151,1.407-13.513h5.218q.093.876.54,6.5l.574,7.494q.452-7.153,1.408-13.994Z",
  transform: "translate(-361.878 -15.889)",
  fill: "#004d99"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1458",
  "data-name": "Path 1458",
  d: "M563.169,20.868h8.423v3.948h-3.373v3.733h3.162v3.733h-3.162V36.6h3.714v3.947h-8.764Z",
  transform: "translate(-428.791 -15.889)",
  fill: "#004d99"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1459",
  "data-name": "Path 1459",
  d: "M605.917,20.868h3.577a26.89,26.89,0,0,1,4.825.283,3.3,3.3,0,0,1,2.064,1.424,6.542,6.542,0,0,1,.8,3.661,5.831,5.831,0,0,1-.559,3.086,2.964,2.964,0,0,1-2.225.946,3.8,3.8,0,0,1,2.018,1.009,3.05,3.05,0,0,1,.641,1.161,19.369,19.369,0,0,1,.125,2.916v5.192H612.5v-6.54a4.578,4.578,0,0,0-.251-1.959q-.242-.375-1.282-.376v8.876h-5.052Zm5.052,3.363V28.6a2.16,2.16,0,0,0,1.185-.236c.227-.158.349-.669.349-1.536V25.747a1.68,1.68,0,0,0-.331-1.226,1.842,1.842,0,0,0-1.2-.29",
  transform: "translate(-461.339 -15.889)",
  fill: "#004d99"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1460",
  "data-name": "Path 1460",
  d: "M30.946,86.719c0,2.8-6.927,5.066-15.473,5.066S0,89.519,0,86.719,6.929,81.66,15.473,81.66s15.473,2.268,15.473,5.059",
  transform: "translate(0 -62.175)",
  fill: "#afbd00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1461",
  "data-name": "Path 1461",
  d: "M37.456,24.823s-7.59,5.874-15.323.974A12.064,12.064,0,0,1,17.845,9.219c2.095-3.066,8.1-7.2,14.239-2.689,0,0,4.335,2.914,3.184,7.852-1.13,4.813-6.364,6.5-6.364,6.5C33.8,21.6,38.16,17,37.8,11.538A12.448,12.448,0,0,0,27.3.49a12.75,12.75,0,0,0-9.176,2.556C20.377.491,24.857-.674,29.266.4a13.775,13.775,0,0,1,10.2,11.814A10.532,10.532,0,0,1,30.21,23.8c-4.205.345-9.833-2.171-9.985-8.3S26.594,7.8,26.594,7.8s-2.028-1.644-5.571.9c0,0-5.316,3.532-3.017,10.624s11.4,10.7,19.451,5.5",
  transform: "translate(-12.304 0)",
  fill: "#004d99"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9887",
    "data-name": "Group 9887",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155.844,
    height: 29.609,
    viewBox: "0 0 155.844 29.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f8dd471e.svg";
export { ForwardRef as ReactComponent };